import { Product } from '@/shared/api';

const createProduct = (product: Omit<Product, 'id'>) => ({
  id: product.article,
  ...product,
});

const cleanMussVitC = createProduct({
  title: 'Очищающий мусс с витамином С',
  images: [
    '/static/products/1001/1.jpg',
    '/static/products/1001/2.jpg',
    '/static/products/1001/3.jpg',
    '/static/products/1001/4.jpg',
    '/static/products/1001/5.jpg',
    '/static/products/1001/6.jpg',
  ],
  price: 891,
  description:
    'Бережно очищает кожу и ускоряет процесс отшелушивания мертвых частиц. Осветляет и выравнивает тон кожи, борется с пигментацией, придает матовый и ухоженный вид.',
  components:
    'Каштан, молочная кислота, аскорбиновая кислота, экстракт зеленого чая, экстракт рыжика, экстракт ламинарии, витамин Е',
  article: 1001,
  methods:
    'На влажное лицо нанести небольшое количество пенки массажными движениями, особое внимание уделять Т-зоне (лоб, нос, подбородок). Оставить на 1 минуту, смыть теплой водой.',
  cautions: 'Только для наружного применения',
  hint: 'Для всех типов кожи.Срок хранения 24 месяца.',
  composition:
    'Aqua, Cocamidopropyl Betaine, Disodium Laureth Sulfosuccinate, Glycerin, Aesculus Hippocastanum Extract, Lactic Acid, Camelina Sativa Seed Oil, Ascorbic Acid, Camellia Sinensis Leaf Extract, Laminaria Digitata Powder, Tocopheryl Acetate, PEG-40 Hydrogenated Castor Oil, Trideceth-9, Parfum, Benzoic Acid, Sorbic Acid, Dehydroacetic Acid, Benzyl Alcohol.',
});

const penka = createProduct({
  title: 'Пенка для умывания Интенсивное увлажнение',
  images: [
    '/static/products/1005/1.jpg',
    '/static/products/1005/2.jpg',
    '/static/products/1005/3.jpg',
    '/static/products/1005/4.jpg',
    '/static/products/1005/5.jpg',
    '/static/products/1005/6.jpg',
  ],
  price: 637,
  description:
    'Бережно очищает кожу и ускоряет процесс отшелушивания мертвых частиц. Увлажняет и выравнивает тон кожи, придает матовый и ухоженный вид.    ',
  components: 'Пантенол, алоэ вера, мочевина, трегалоза, фукогель, ниацинамид, молочная кислота',
  article: 1005,
  methods:
    'Нанести пенку на увлажненную кожу лица массажными движениями. Оставить средство на коже 5 секунд, смыть теплой проточной водой.',
  cautions: 'Только для наружного применения.',
  hint: 'Для всех типов кожи.Срок хранения 24 месяца.',
  composition:
    'Aqua, glycerin, cocamidopropyl betaine, coco-glucoside, panthenol, aloe barbadensis (aloe vera) leaf gel, peg - 40 hydrogenated castor oil, urea, trehalose, biosaccharide gum-1, niacinamide, lactic acid, methylchloroisothiazolinone and methylisothiazolinone',
});

const gelDlyUmyvaniya = createProduct({
  title: 'Гель для умывания Уголь-Цинк',
  images: [
    '/static/products/1009/1.jpg',
    '/static/products/1009/2.jpg',
    '/static/products/1009/3.jpg',
    '/static/products/1009/4.jpg',
    '/static/products/1009/5.jpg',
    '/static/products/1009/6.jpg',
  ],
  price: 564,
  description:
    'Удаляет загрязнения и отшелушивает кожу, уменьшает жирный блеск и борется с акне, предотвращая их распространение. Обладает успокаивающими и заживляющими свойствами, снимает покраснения, заметно улучшает тон кожи, делает его ровным и здоровым. ',
  components: 'Оксид цинка, пантенол, мочевина, экстракт чайного дерева, экстракт лотоса',
  article: 1009,
  methods: 'Нанести небольшое количество геля на кожу лица массажными движениями. Смыть остатки средства теплой водой.',
  cautions: 'Только для наружного применения',
  hint: 'Для  жирной и комбинированной кожи. Срок хранения 24 мес.',
  composition:
    'Aqua, Cocamidopropyl Betaine, Sodium Laureth Sulfate, Sodium Chloride, Coco-Glucoside, Glyceryl Oleate, Glycerin, Urea, Carbo Activates, Zinc Oxide, Panthenol, Melaleuca Alternifolia Extract, Nelumbo Nucifera Leaf Extract, Protein Hydrolyzates Milk, Citric Acid, PEG-75 Lanolin, Parfum, Benzoic Acid, Sorbic Acid, Dehydroacetic Acid, Benzyl Alcohol.',
});

const osvetTonik = createProduct({
  title: 'Осветляющий тоник с витамином С',
  images: [
    '/static/products/1002/1.jpg',
    '/static/products/1002/2.jpg',
    '/static/products/1002/3.jpg',
    '/static/products/1002/4.jpg',
  ],
  price: 608,
  description: 'Осветляет пигментные пятна и следы акне, бережно отшелушивает, выравнивает тон и рельеф кожи лица.',
  components: 'Молочная кислота, гликолевая кислота, витамин С, яблочная кислота, экстракт семян льна',
  article: 1002,
  methods: 'Распылить на кожу лица. Не смывать.',
  cautions: 'Только для наружного применения',
  hint: 'Для всех типов кожи. Срок хранения 24 мес.',
  composition:
    'Aqua, Linum Usitatissimum Seed Extract, Lactic Acid, Ascorbyl Palmitate, Citric Acid, Glycolic Acid, Malic Acid, Triethanolamine, PEG-40 Hydrogenated Castor Oil, Trideceth-9, Cocamidopropyl Betaine, Benzoic Acid, Sorbic Acid, Dehydroacetic Acid, Benzyl Alcohol.',
});

const faceTonik = createProduct({
  title: 'Тоник для лица интенсивное увлажнение',
  images: [
    '/static/products/1006/1.jpg',
    '/static/products/1006/2.jpg',
    '/static/products/1006/3.jpg',
    '/static/products/1006/4.jpg',
    '/static/products/1006/5.jpg',
  ],
  price: 626,
  description:
    'Огуречный экстракт освежает и дарит ощущение увлажненности, удаляет остатки загрязнений, оставшихся после умывания, сохраняет баланс кожи. Алоэ гель успокоит чувствительную кожу.',
  components: 'алоэ вера гель, экстракт огурца',
  article: 1006,
  methods: '1. Нанести тоник на ватный диск, распределить по лицу. 2.Распылить на кожу лица. Не смывать.',
  cautions: 'Только для наружного применения',
  hint: 'Для всех типов кожи. Срок хранения 24 мес.',
  composition:
    'Аqua, aloe barbadensis (aloe vera) leaf gel, glycerin, peg-7 olive oil, cucumis sativus (cucumber) seed extract, parfum, potassium sorbate, sodium benzoate',
});

const oilyFaceTonik = createProduct({
  title: 'Тоник для жирной кожи с салициловой кислотой',
  images: [
    '/static/products/1010/1.jpg',
    '/static/products/1010/2.jpg',
    '/static/products/1010/3.jpg',
    '/static/products/1010/4.jpg',
    '/static/products/1010/5.jpg',
    '/static/products/1010/6.jpg',
  ],
  price: 626,
  description:
    'Тоник с салициловой кислотой, очищает лицо от жирного блеска, замедляет процессы работы сальных желез, растворяет сальные пробки. Борется с проявлением акне.',
  components: 'Мочевина, салициловая кислота, молочная кислота, экстракт календулы, цинк',
  article: 1010,
  methods: '1. Нанести тоник на ватный диск, распределить по лицу. 2.Распылить на кожу лица. Не смывать.',
  cautions: 'Только для наружного применения',
  hint: 'Для жирной и комбинированной кожи. Срок хранения 24 мес.',
  composition:
    'Aqua, propylene glycol, urea, sodium salicylate, peg-40 hydrogenated castor oil, sodium chloride, salicylic acid, ammonium alum, lactic acid, calendula officinalis extract, zinc pca parfum, benzoic acid, sorbic acid, dehydroacetic acid, benzyl alcohol.',
});

const syvorotkaVit = createProduct({
  title: 'Сыворотка с витамином С, 5%',
  images: [
    '/static/products/1003/1.jpg',
    '/static/products/1003/2.jpg',
    '/static/products/1003/3.jpg',
    '/static/products/1003/4.jpg',
    '/static/products/1003/5.jpg',
  ],
  price: 684,
  description:
    'Сыворотка выравнивает тон и улучшает цвет лица, защищает стенки сосудов и уменьшает их ломкость, осветляет следы постакне и пигментные пятна, улучшает структуру кожи, освежает и создает эффект естественного сияния.',
  components: 'Алоэ вера сок, витамин С, мочевина, пантенол, молочная кислота, витамин Е, эфирное масло вербены',
  article: 1003,
  methods:
    'Нанести несколько капель сыворотки на лицо или растереть между ладонями, распределить по лицу аккуратными массирующими движениями. После того, как сыворотка впитается, нанести сверху крем. Не смывать.',
  cautions: 'Только для наружного применения',
  hint: 'Для всех типов кожи. Срок хранения 24 мес.',
  composition:
    'Aqua, ascorbyl palmitate (vitamin c palmitate), glycerin, aloe barbadensis leaf juice, urea, panthenol, xanthan gum, lactic acid, tocopherol, peg-6 caprylic/ capric glyceride, lippia citriodora leaf/flower oil, parfum, methylchloroisothiazolinone and methylisothiazolinone',
});

const syvorotkaAcid = createProduct({
  title: 'Сыворотка, увлажняющая с гиалуроновой кислотой',
  images: [
    '/static/products/1007/1.jpg',
    '/static/products/1007/2.jpg',
    '/static/products/1007/3.jpg',
    '/static/products/1007/4.jpg',
    '/static/products/1007/5.jpg',
  ],
  price: 747,
  description:
    'Сыворотка увлажняет кожу, устраняет сухость и шелушение, повышает эластичность кожи, нивелирует возрастные изменения кожи и смягчает ее.',
  components:
    'Алоэ вера сок, гиалуроновая кислота, мочевина, пантенол, молочная кислота, витамин Е, эфирное масло бергамота',
  article: 1007,
  methods:
    'Нанести несколько капель сыворотки на лицо или растереть между ладонями, распределить по лицу аккуратными массирующими движениями. При необходимости нанести сверху крем. Не смывать.',
  cautions: 'Только для наружного применения',
  hint: 'Для всех типов кожи. Срок хранения 24 мес.',
  composition:
    'Aqua, glycerin, aloe barbadensis leaf juice, urea, hyaluronic acid, panthenol, xanthan gum, lactic acid, tocopherol, peg-6 caprylic/ capric glyceride, citrus aurantium bergamia (bergamot) essential oil, parfum, methylchloroisothiazolinone and methylisothiazolinone',
});

const syvorotkaSebo = createProduct({
  title: 'Себорегулирующая сыворотка с ниацинамидом 10%',
  images: [
    '/static/products/1011/1.jpg',
    '/static/products/1011/2.jpg',
    '/static/products/1011/3.jpg',
    '/static/products/1011/5.jpg',
  ],
  price: 670,
  description:
    'Сыворотка с ниацинамидом 10% и цинком 1% предназначена для ухода за проблемной кожей, устранения кожных высыпаний и уменьшения жирности кожи, избавляет от воспалений и пигментации. Сыворотка так же нацелена на работу с пятнами постакне и борьбы с черными точками',
  components: 'Ниацинамид, цинк, алоэ вера сок, мочевина, пантенол, молочная кислота, витамин Е',
  article: 1011,
  methods:
    'Нанести несколько капель сыворотки на лицо или растереть между ладонями, распределить по лицу аккуратными массирующими движениями. При необходимости нанести сверху крем. Не смывать.',
  cautions: 'Только для наружного применения',
  hint: 'Для жирной и комбинированной кожи. Срок хранения 24 мес.',
  composition:
    'Aqua, Niacinamide, aloe barbadensis leaf juice, Zinc Pса, Glycerin, Panthenol, Urea, Xanthan Gum, lactic acid, Tocopherol, Peg-6 Caprylic/ Capric Glyceride, Parfum, Methylchloroisothiazolinone And Methylisothiazolinone',
});

const creamVitC = createProduct({
  title: 'Омолаживающий крем с витамином С и коллагеном',
  images: [
    '/static/products/1004/1.jpg',
    '/static/products/1004/2.jpg',
    '/static/products/1004/3.jpg',
    '/static/products/1004/4.jpg',
    '/static/products/1004/5.jpg',
    '/static/products/1004/6.jpg',
    '/static/products/1004/7.jpg',
    '/static/products/1004/8.jpg',
    '/static/products/1004/9.jpg',
  ],
  price: 1301,
  description:
    'Коллаген увлажняет кожу, придает упругость, за счет притягивания влаги и предотвращает ее испарение, выравнивает поверхность кожи. Витамин С стимулирует выработку коллагена в дерме. Борется со всеми проявлениями фотостарения: утолщением и неровностью кожи, пигментными пятнами. Экстракт имбиря восстанавливает энергетический баланс кожи, экстракт арники активизирует кровообращение, способствует выводу токсинов, ускоряет внутрикожный метаболизм, существенно сокращает отеки. Эфирное масло кедра омолаживающими свойствами, успокаивает, тонизирует.',
  components:
    'Коллаген, витамин С, масло кокоса, масло виноградной косточки, мочевина, молочная кислота, экстракт имбиря, экстракт арники, эфирное масло кедра',
  article: 1004,
  methods: 'Нанести крем на кожу легкими массирующими движениями. Не смывать.',
  cautions: 'Только для наружного применения',
  hint: 'Для всех типов кожи. Срок хранения 24 мес.',
  composition:
    'Aqua, glyceryl monostearate, glycerin, cocos nucifera (coconut) oil, stearyl alcohol, cetyl alcohol, peg-2 stearate se, vitis vinifera(grape) seed oil, urea, soluble collagen, polysorbate-20, ascorbyl palmitate (vitamin c palmitate), lactic acid, dipropylene glycol, stearyl dimethicone, peg-6 caprylic /capric glycerides, zingiber officinale (ginger) extract, arnica montana (arnica) flower extract, oil of cedarwood atlas, methylchloroisothiazolinone and methylisothiazolinone',
});

const creamMilk = createProduct({
  title: 'Лифтинг крем "интенсивное увлажнение" с молочной кислотой',
  images: [
    '/static/products/1008/1.jpg',
    '/static/products/1008/2.jpg',
    '/static/products/1008/3.jpg',
    '/static/products/1008/4.jpg',
    '/static/products/1008/5.jpg',
    '/static/products/1008/6.jpg',
    '/static/products/1008/7.jpg',
    '/static/products/1008/8.jpg',
    '/static/products/1008/9.jpg',
  ],
  price: 1233,
  description:
    'Fucogel (Фукогель) — это полисахарид на основе фукозы, который влияет на коммуникацию клеток кожи. Он признан многофункциональным эталонным компонентом в косметике, который оказывает мгновенное успокаивающее, увлажняющее, антивозрастное и восстанавливающее действие на кожу. Пантенол и молочная кислота глубоко увлажняют, алоэ успокаивает кожу. Экстракт полыни увлажняет и успокаивает кожу. Оказывает бактерицидное, антисептическое, противовоспалительное действие, нормализует гидро-липидный баланс кожи.',
  components:
    'Фукогель, пантенол, молочная кислота, масло кокоса, масло виноградной косточки, мочевина, экстракт алоэ, экстракт полыни',
  article: 1008,
  methods: 'Нанести крем на кожу легкими массирующими движениями. Не смывать.',
  cautions: 'Только для наружного применения',
  hint: 'Для всех типов кожи. Срок хранения 24 мес.',
  composition:
    'Aqua, glyceryl monostearate, glycerin, biosaccharide gum-1, cocos nucifera (coconut) oil, stearyl alcohol, cetyl alcohol, peg-2 stearate se, vitis vinifera(grape) seed oil, panthenol, urea, polysorbate-20, lactic acid, dipropylene glycol, stearyl dimethicone, peg-6 caprylic /capric glycerides, aloe vera extract, artemisia vulgaris (mugwort) extract, parfum, methylchloroisothiazolinone and methylisothiazolinone',
});

const pantenolGel = createProduct({
  title: 'Пантеноловый гель для жирной кожи ',
  images: [
    '/static/products/1012/1.jpg',
    '/static/products/1012/2.jpg',
    '/static/products/1012/3.jpg',
    '/static/products/1012/4.jpg',
    '/static/products/1012/5.jpg',
  ],
  price: 747,
  description:
    'Гель обеспечивает эффективное долгосрочное увлажнение, за счет большого содержания гидрованса и алоэ-вера геля. Пантенол удерживает влагу, экстракты заживляют и снимают воспаления.',
  components: 'Алоэ вера гель, гидрованс, пантенол, экстракт ромашки, экстракт зеленого чая',
  article: 1012,
  methods: 'Нанести крем на кожу легкими массирующими движениями. Не смывать.',
  cautions: 'Только для наружного применения',
  hint: 'Для жирной, комбинированной кожи. Срок хранения 24 мес.',
  composition:
    'Аqua (water), aloe barbadensis (aloe vera) leaf gel, glycerin, hydroxyethylurea, carbomer, panthenol, chamomilla recutita flower/leaf/stem extract, green tea extract, triethanolamine, potassium sorbate, sodium benzoate, parfum',
});

const creamEye = createProduct({
  title: 'Крем-лифтинг вокруг глаз «Комплекс морских водорослей»',
  images: [
    '/static/products/1013/1.jpg',
    '/static/products/1013/2.jpg',
    '/static/products/1013/3.jpg',
    '/static/products/1013/4.jpg',
    '/static/products/1013/5.jpg',
    '/static/products/1013/6.jpg',
    '/static/products/1013/7.jpg',
  ],
  price: 770,
  description:
    'Миндальное масло улучшает цвет лица, придаёт коже гладкость, повышает эластичность и разглаживает морщины. Витамин Е оказывает антиоксидантное действие.Спирулина оказывает антивозрастной эффект. Ламинария улучшает тонус кожи, помогает улучшить кровообращение и лимфоток. Фукус снимает отечность, подтягивает кожу, замедляет старение. Эфирное масло вербены освежает и выравнивает цвет кожи.',
  components:
    'Масло сладкого миндаля, кокосовое масло, витамин Е, экстракт спирулины, экстракт ламинарии, экстракт фукуса, эфирное масло вербены лимонной',
  article: 1013,
  methods:
    'Нанести крем на кожу вокруг глаз массажными движениями до полного впитывания. Подходит для ежедневного применения.',
  cautions: 'Только для наружного применения',
  hint: 'Для всех типов кожи. Срок хранения 24 мес.',
  composition:
    'Aqua, glyceryl monostearate, glycerin, sweet almond oil, cocos nucifera (coconut) oil, stearyl alcohol, cetyl alcohol, peg-2 stearate se, polysorbate-20, lactic acid, tocopherol, peg-40 hydrogenated castor oil, dipropylene glycol, stearyl dimethicone, spirulina maxima extract, laminaria digitata extract, fucus vesiculosus extract, lippia citriodora leaf/flower oil, peg-6 caprylic /capric glycerides, methylchloroisothiazolinone and methylisothiazolinone',
});

const micWater = createProduct({
  title: 'Мицеллярная вода для снятия макияжа с Д-пантенолом ',
  images: [
    '/static/products/1015/1.jpg',
    '/static/products/1015/2.jpg',
    '/static/products/1015/3.jpg',
    '/static/products/1015/4.jpg',
    '/static/products/1015/5.jpg',
  ],
  price: 443,
  description: 'Деликатно удаляет макияж, очищает от загрязнений, устраняет чувство сухости, стянутости и шелушения.',
  components: 'Пантенол, зеленый чай, алоэ, витамин Е',
  article: 1015,
  methods:
    '1. Нанести мицеллярную воду на ватный диск и протереть лицо. Смыть теплой водой. 2. Распылить на кожу лица, массажными движениями распределить по коже. Смыть теплой водой.',
  cautions: 'Только для наружного применения',
  hint: 'Для всех типов кожи. Срок хранения 24 мес.',
  composition:
    'Aqua, Propylene Glycol, Panthenol, Camellia Sinensis Leaf Extract, Aloe Barbadensis Extract, Tocopheryl Acetate, PEG-40 Hydrogenated Castor Oil, Trideceth-9, Parfum, Citric Acid, Phenoxyethanol.',
});

const pudra = createProduct({
  title: 'Энзимная пудра для умывания',
  images: [
    '/static/products/1016/1.jpg',
    '/static/products/1016/2.jpg',
    '/static/products/1016/3.jpg',
    '/static/products/1016/4.jpg',
  ],
  price: 698,
  description:
    'Устраняет черные точки и различные высыпания, отшелушивает омертвевшие клетки, осветляет и выравнивает тон лица. Устраняет воспалительные процессы, хорошо увлажняет и питает, снимает покраснения и раздражения.  Можно использовать как средство для умывания и скраб для лица.',
  components:
    'Аллантоин, Салициловая кислота, Янтарная кислота, лимонная кислота, Папаин, Экстракт корня женьшеня Panax, экстракт корня родиолы розовой',
  article: 1016,
  methods:
    '1. Небольшое количество пудры насыпать на ладонь, добавить воды и вспенить полученную консистенцию. Нанести на кожу лица массажными движениями. Смыть остатки средства теплой водой. 2. Небольшое количество пудры нанести на влажную кожу массажными движениями. Остатки средства смыть теплой водой.',
  cautions: 'Только для наружного применения',
  hint: 'Для всех типов кожи. Срок хранения 24 мес.',
  composition:
    'Corn Starch, Talc, Sodium Coco-Sulfate, Allantoin, Salicylic Acid, Succinic Acid, Citric Acid, Papain, Panax Ginseng Root Extract, Rhodiola Rosea Root Extract, Paeonia Officinalis Root Extract, Ananas Sativus (Pineapple) Extract.',
});

const waterPatch = createProduct({
  title: 'Жидкие патчи Антистресс "Пептиды шёлка и Витамин E"',
  images: [
    '/static/products/1014/1.jpg',
    '/static/products/1014/2.jpg',
    '/static/products/1014/3.jpg',
    '/static/products/1014/4.jpg',
    '/static/products/1014/5.jpg',
  ],
  price: 702,
  description:
    'Мягкое действие патчей направлено на восстановление кожи, снятие отечности, темных кругов и стресса. Успокаивает кожу, увлажняет и питает ее. Витамин Е и шелк омолаживают и обладают лифтинг-эффектом',
  components: 'Бадяга, каштан, пантенол, алоэ, зеленый чай, витамин Е, аллантоин, ананас, персик, шёлк',
  article: 1014,
  methods:
    'Нанести жидкие патчи на кожу вокруг глаз. Время воздействия 15-20 минут. По истечению времени остатки средства удалить при помощи влажной салфетки. При необходимости средство можно оставить до полного впитывания.',
  cautions: 'Только для наружного применения',
  hint: 'Для всех типов кожи. Срок хранения 24 мес.',
  composition:
    'Aqua, Glycerin, Spongilla Lacustris, Aesculus Hippocastanum Extract, Panthenol, Aloe Barbadensis Extract, Camellia Sinensis Leaf Extract, Tocopheryl Acetate, Allantoin, Carbomer, Ananas Sativus (Pineapple) Extract, Prunus Persica (Peach) Extract, Hydrolyzed Silk Peptides, PEG-75 Lanolin, Potassium Hydroxide, Parfum, Benzoic Acid, Sorbic Acid, Dehydroacetic Acid, Benzyl Alcohol.',
});

const expressMask = createProduct({
  title: 'Экспресс-маска для лица "Кофеин-Каштан"',
  images: [
    '/static/products/1017/1.jpg',
    '/static/products/1017/2.jpg',
    '/static/products/1017/3.jpg',
    '/static/products/1017/4.jpg',
    '/static/products/1017/5.jpg',
    '/static/products/1017/6.jpg',
    '/static/products/1017/7.jpg',
  ],
  price: 1143,
  description:
    'Каштан оказывает антиоксидантное, противоотёчное и противовоспалительное действие на кожу, борется с раздражениями и покраснениями. Кофеин стимулирует кровообращение и заметно улучшают состояние кожи вокруг глаз, помогая убрать затенения, которые визуально увеличивают круги в этой области. Масло жожоба помогает разглаживать морщинки и эффективно борется с сухостью кожи. Отбеливает лицо от пигментации, устраняет любые очаги воспалений и улучшает состояние кожи.',
  components: 'Кофеин, экстракт каштана, масло жожоба, масло ши, масло какао',
  article: 1017,
  methods: 'Нанести на очищенную кожу лица, оставить на 15-20 минут, смыть теплой водой. После нанести крем.',
  cautions: 'Только для наружного применения',
  hint: 'Для всех типов кожи. Срок хранения 24 мес.',
  composition:
    'Aqua, kaolin, glyceryl monostearate, glycerin, stearyl alcohol, cetyl alcohol, peg-2 stearate se, soja oil, simmondsia chinensis (jojoba) seed oil, theobroma cacao seed butter, cocos nucifera (coconut) oil, caffeine, soja wax, shea butter, beeswax, caprylyl methicone, polysorbate-20, peg-40 hydrogenated castor oil, dipropylene glycol, aesculus hippocastanum extract, aloe vera extract, peg-6 caprylic /capric glycerides, methylchloroisothiazolinone and methylisothiazolinone',
});

const osvetMask = createProduct({
  title: 'Маска осветляющая с витамином С и ниацинамидом',
  images: [
    '/static/products/1018/1.jpg',
    '/static/products/1018/2.jpg',
    '/static/products/1018/3.jpg',
    '/static/products/1018/4.jpg',
    '/static/products/1018/5.jpg',
    '/static/products/1018/6.jpg',
  ],
  price: 1121,
  description:
    'Ниацинамид осветляет пигментные пятна и постакне, восстанавливает барьерную функцию дермы, нивелируя шелушения, раздражения и обезвоженность, улучшает цвет лица, убирает тусклость. Витамин С улучшает структуру кожи, осветляет следы постакне и пигментные пятна, освежает и создает эффект естественного сияния. Комплекс фруктовых кислот осветляют и выравнивают тон лица. Экстракт зеленого кофе активизирует обменные процессы, в частности жировой и водный обмен, смягчает и защищает эпидермальный слой, экстракт виноградных косточек стабилизирует выработку коллагена и эластина, отвечает за молодость и упругость кожи.',
  components:
    'Ниацинамид, витамин С, кокосовое масло, масло миндаля, мочевина, молочная кислота, гликолевая кислота, винная кислота, яблочная кислота, экстракт зеленого кофе, экстракт виноградной косточки',
  article: 1018,
  methods: 'Нанести на очищенную кожу лица, оставить на 15-20 минут, смыть теплой водой. После  нанести крем.',
  cautions: 'Только для наружного применения',
  hint: 'Для всех типов кожи. Срок хранения 24 мес.',
  composition:
    'Aqua, niacinamide, ascorbyl palmitate, glyceryl monostearate, glycerin, cocos nucifera (coconut) oil, stearyl alcohol, cetyl alcohol, peg-2 stearate se, sweet almond oil, soja wax, urea, polysorbate-20, lactic acid, peg-40 hydrogenated castor oil, dipropylene glycol, stearyl dimethicone, peg-6 caprylic /capric glycerides, glycolic acid, malic acid, tartaric acid, coffea (green coffee) extract, vitis vinifera seed extract, parfum, methylchloroisothiazolinone and methylisothiazolinone',
});

const oilConcentration = createProduct({
  title: 'Oil-концентрат для массажа лица',
  images: [
    '/static/products/1019/1.jpg',
    '/static/products/1019/2.jpg',
    '/static/products/1019/3.jpg',
    '/static/products/1019/4.jpg',
    '/static/products/1019/5.jpg',
    '/static/products/1019/6.jpg',
    '/static/products/1019/7.jpg',
    '/static/products/1019/8.jpg',
  ],
  price: 688,
  description:
    'Увлажняющее легкое масло для кожи. Увлажняет и питает кожу, придает сияние и ухоженный вид, повышается эластичность и упругость кожи. Прекрасно подходит для мануального массажа, массажа скребком гуаша и т.д.',
  components: 'Каприлик, масло миндальное, масло виноградной косточки, витамин Е',
  article: 1019,
  methods: 'Нанести несколько капель масла на ладонь и распределить по лицу перед массажем.',
  cautions: 'Только для наружного применения',
  hint: 'Для всех типов кожи. Срок хранения 24 мес.',
  composition:
    'Caprylic /capric triglycerides, prunus amygdalus dulcis (sweet almond) oil, vitis vinifera (grape) seed oil, tocopheryl acetat',
});

const creamIntens = createProduct({
  title: 'Интенсивный крем-уход 3 в 1 для рук',
  images: [
    '/static/products/1020/1.jpg',
    '/static/products/1020/2.jpg',
    '/static/products/1020/3.jpg',
    '/static/products/1020/4.jpg',
  ],
  price: 456,
  description:
    'Питает, заживляет, восстанавливает, смягчает, активизирует регенерацию клеток, защищает от агрессивного воздействия внешних факторов среды.',
  components: 'Пантенол, кокосовое масло, масло Ши, ментол, витамин F.',
  article: 1020,
  methods:
    'Небольшое количество крема нанести на сухую, очищенную кожу. Втирать массажными движениями до полного впитывания.',
  cautions: 'Только для наружного применения',
  hint: 'Для всех типов кожи. Срок хранения 24 мес.',
  composition:
    'Aqua, Paraffinum Liquidum, Cetearyl Alcohol, Isopropyl Palmitate, Panthenol, Glycerin, Cocos Oil, Butyrospermum Parkii Oil,Menthol, Propylene Glycol, PEG-40 Hydrogenated Castor Oil, Glyceryl Stearate, Ceteareth-20, Ceteareth-12, Cetyl Palmitate, PEG-100 Stearate, Carbomer, Vitamin F, Parfum, Phenoxyethanol, Methylparaben, Ethylparaben, CI 16035.',
});

const creamParafin = createProduct({
  title: 'Крем парафин для рук с витамином Е',
  images: [
    '/static/products/1021/1.jpg',
    '/static/products/1021/2.jpg',
    '/static/products/1021/3.jpg',
    '/static/products/1021/4.jpg',
    '/static/products/1021/5.jpg',
    '/static/products/1021/6.jpg',
  ],
  price: 705,
  description:
    'Защищает кожу от агрессивного воздействия окружающей среды, увлажняет кожу, благотворно влияет на обветренную кожу.',
  components: 'Парафин, кокосовое масло, масло ши, витамин е, ретинол',
  article: 1021,
  methods:
    '1. Нанести небольшое количество крем-парафина на руки, втереть до полного впитывания. 2.Нанести небольшое количество крем-парафина на кожу, надеть полиэтиленовые перчатки. Оставить на 10-20 минут. Снять перчатки, убрать остатки крем-парафина салфеткой.',
  cautions: 'Только для наружного применения',
  hint: 'Для всех типов кожи. Срок хранения 24 мес.',
  composition:
    'Paraffinum Liquidum, Paraffin, Isopropyl Myristate, Hydrogenated Microcrystalline Wax, Cocos Nucifera Oil, Butyrospermum Parkii Oil, Tocopheryl Acetate, Retinyl Palmitate, Linoleic Acid, Parfum.',
});

export const products: Product[] = [
  cleanMussVitC,
  penka,
  gelDlyUmyvaniya,
  osvetTonik,
  faceTonik,
  oilyFaceTonik,
  syvorotkaVit,
  syvorotkaAcid,
  syvorotkaSebo,
  creamVitC,
  creamMilk,
  pantenolGel,
  creamEye,
  micWater,
  pudra,
  waterPatch,
  expressMask,
  osvetMask,
  oilConcentration,
  creamIntens,
  creamParafin,
];
